// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".country-wrapper{display:flex;flex-direction:column;font-size:14px;color:#061632;line-height:20px}.country-wrapper .country-header{display:flex;align-items:center;padding:2px 0}.country-wrapper .country-header .country-code{margin-right:4px}.country-wrapper .country-name .em{display:inline-block;margin-left:4px;color:red}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
